import Fuse from "fuse.js";
import { useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FilterToggle from "../../atoms/FilterToggle";
import { optionsTypesGastos } from "../../../utils/gastosTypes.js";

const GastosFilter = ({ filters, options, setFilters }) => {
    const [selectedInmuebles, setSelectedInmuebles] = useState([]);

    const handleDateRangeChange = (dates) => {
        const [start, end] = dates;
        setFilters(prev => ({
            ...prev,
            dateRange: { start, end }
        }));
    };

    const handleReset = () => {
        setFilters({
            name: "",
            inmuebles: [],
            dateRange: { start: null, end: null },
        });
        setSelectedInmuebles([]);
    };

    return (
        <FilterToggle>
            <div className="w-full flex flex-col">
                <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <Select
                            name="name"
                            options={optionsTypesGastos}
                            value={optionsTypesGastos.find(opt => opt.value === filters.name) || null}
                            onChange={(selected) => { setFilters(prev => ({ ...prev, name: selected?.value || "" })); }}
                            isClearable
                            placeholder="Selecciona tipo de gasto..."
                            classNamePrefix="select"
                            className="w-full border rounded-md"
                        />
                    </div>
                    <div>
                        <Select
                            isMulti
                            name="inmuebles"
                            value={selectedInmuebles}
                            onChange={(selected) => {
                                setSelectedInmuebles(selected || []);
                                setFilters(prev => ({ ...prev, inmuebles: selected?.map(sel => sel.value) || [], })); }}
                            options={options}
                            filterOption={createFuseFilter(options, ["label"])}
                            placeholder="Filtrar por inmueble(s)..."
                            classNamePrefix="select"
                            className="w-full border rounded-md"
                        />
                    </div>
                    <div className="w-full">
                        <DatePicker
                            selectsRange
                            startDate={filters.dateRange.start}
                            endDate={filters.dateRange.end}
                            onChange={handleDateRangeChange}
                            placeholderText="Rango de fecha"
                            className="border-2 border-gray-300 p-1 rounded w-full min-w-0"
                            isClearable
                            dateFormat="dd/MM/yy"
                        />
                    </div>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={handleReset}
                        className="text-gray-500 text-xs p-1"
                    >
                        Limpiar filtros
                    </button>
                </div>
            </div>
        </FilterToggle>
    );
};

export default GastosFilter;

const createFuseFilter = (optionsList, keys) => {
    const fuse = new Fuse(optionsList, {
        keys,
        threshold: 0.3,
        ignoreLocation: true,
        includeScore: false,
        useExtendedSearch: true,
    });

    return (candidate, input) => {
        if (!input) return true;
        const results = fuse.search(input);
        return results.some(res => res.item.value === candidate.value);
    };
};
